import { render, staticRenderFns } from "./AttachDocument.vue?vue&type=template&id=3e1a23b6&scoped=true"
import script from "./AttachDocument.vue?vue&type=script&lang=js"
export * from "./AttachDocument.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/component/panel-simple.css?vue&type=style&index=0&id=3e1a23b6&prod&scoped=true&lang=css&external"
import style1 from "@/assets/css/component/badge.css?vue&type=style&index=1&prod&lang=css&external"
import style2 from "@/assets/css/component/textarea.css?vue&type=style&index=2&prod&lang=css&external"
import style3 from "./AttachDocument.vue?vue&type=style&index=3&id=3e1a23b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e1a23b6",
  null
  
)

export default component.exports